export default "<ion-app>\r\n \r\n  <app-menu></app-menu>\r\n  <ion-router-outlet id=\"principal\"></ion-router-outlet>\r\n</ion-app>\r\n"